import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_INPUT_UNASSIGNED_SCHEMA = Object.freeze({
  INPUT_ID: '',
  INPUT_LOCAL_ID: '',
  INPUT_TYPE: '',
});
const RECORD = generateSchema(TRACKING_INPUT_UNASSIGNED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_INPUT_UNASSIGNED_SCHEMA);

export class InputUnassignedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.input_unassigned;
  }

  get properties() {
    return this.toJS();
  }
}
